import { useHamburgerButtonPresenter } from '@Components/SideDrawerRight/HamburgerButton/HamburgerButton.presenter';
import OwnableTheme from '@Theme';
import { observer } from 'mobx-react-lite';
import { StyleSheet, TouchableOpacity } from 'react-native';
import styled from 'styled-components/native';

import { Text } from '../../Common/Text';
import { ModalWrapper } from '../ModalWrapper';
import { usePasswordResetModalPresenter } from './PasswordResetModalPresenter';

import ExternalLinkService from '~gateways/external-link';

const PASSWORD_RESET_TOKEN_ENABLED = true;

const Wrapper = styled.View`
  display: flex;
  max-width: 300px;
  align-items: center;
`;

export const PasswordResetModal = observer(function PasswordResetModal() {
  const { visible, hide: hideResetModal } = usePasswordResetModalPresenter();
  const { isOpen } = useHamburgerButtonPresenter();

  const hide = () => {
    hideResetModal();
    isOpen.set(false);
  };

  if (!PASSWORD_RESET_TOKEN_ENABLED) {
    return (
      <ModalWrapper visible={visible.value} onDismiss={hide} onClose={hide}>
        <Text
          align='center'
          color={OwnableTheme.colors.black}
          size='s'
          weight='bold'
        >
          Forgotten your password? Please contact{' '}
        </Text>
        <TouchableOpacity
          onPress={() => {
            ExternalLinkService.openUrl('mailto:support@ownable.uk', '_self');
          }}
        >
          <Text
            align='center'
            color={OwnableTheme.colors.amaranth}
            size='s'
            weight='bold'
            fontStyleOverride={styles.button}
          >
            support@ownable.uk
          </Text>
        </TouchableOpacity>
      </ModalWrapper>
    );
  }

  return (
    <ModalWrapper visible={visible.value} onDismiss={hide} onClose={hide}>
      <Wrapper>
        <Text
          align='center'
          color={OwnableTheme.colors.black}
          size='s'
          weight='bold'
        >
          A password reset link has been sent to your email address
        </Text>
      </Wrapper>
    </ModalWrapper>
  );
});

const styles = StyleSheet.create({ button: { marginTop: 20 } });
